import { render } from "./MockupContainer.vue?vue&type=template&id=fd6419d2&scoped=true"
import script from "./MockupContainer.vue?vue&type=script&lang=js"
export * from "./MockupContainer.vue?vue&type=script&lang=js"

import "./MockupContainer.vue?vue&type=style&index=0&id=fd6419d2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd6419d2"],['__file',"src/scripts/common/components/MockupContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd6419d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd6419d2', __exports__)) {
    api.reload('fd6419d2', __exports__)
  }
  
  module.hot.accept("./MockupContainer.vue?vue&type=template&id=fd6419d2&scoped=true", () => {
    api.rerender('fd6419d2', render)
  })

}


export default __exports__